import { ArrowLeft } from 'lucide-react';
//Button to switch 3D view to 2D view, asdded to the side panel.
const BackToMapButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      style={{
        fontSize:"15px",
        position: "absolute",
        fontWeight: "600",
        top: "10px",
        left: "-5px",
        padding: "8px 8px",
        backgroundColor: "rgb(255, 255, 255)",
        color: "black",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        fontFamily: "GoldbeckNextSemiBold2",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        width:"200px",
        border:"none",
        outline:"none"
      }}
         onMouseOver={(e) => {e.currentTarget.style.backgroundColor = '#EEEFF0'; e.currentTarget.style.color = 'black';}}
         onMouseOut={(e) => {e.currentTarget.style.backgroundColor = 'white'; e.currentTarget.style.color = 'black';}}
    >
      <ArrowLeft size={18} />
      Zurück zur Auswahl
    </button>
  );
};

export default BackToMapButton;